import { Component, OnInit } from '@angular/core';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { SharedService } from 'src/app/service/shared/shared.service';

@Component({
  selector: 'app-three-sixty-degree-logs',
  templateUrl: './three-sixty-degree-logs.component.html',
  styleUrls: ['./three-sixty-degree-logs.component.scss'],
})
export class ThreeSixtyDegreeLogsComponent  implements OnInit {
  buttonColorName:any
  selectedYear:any;
  getIncrementFyYearList:any = [];
  loggedInUserCompanyID:any;
  loggedInCompanyFiscalyear:any;
  selectChangeType:any = "All";
  currentPageNumberOfessLogsTable: any = 1;
  totalPagesOfessLogsTable: any = 0;

  gridData: {
    columnInfo: Array<{ label: string, propertyName: string, sortingName: string }>,
    columnData: Array<any>,
    totalCount: number,
    totalNoOfPages: number,
    showCheckBox: boolean
    showExportBtn: boolean,
    showGraphBtn: boolean
    showSearchBar: boolean,
    showAddBtn: boolean,
    currentPage: number,
    showDeleteBtn: boolean,
    tabsData: Array<any>,
    tabsMainData: Array<any>,
    showAccessConfigBtn: boolean,
    showTitle: boolean,
    showBreadCrumbs: boolean,
    showAuditLog: boolean,
    showPermantDeleteBtn: boolean,
    showRestoreBtn: boolean,
    showImportBtn: boolean,
    showBackBtn: boolean,
    showRefreshFunctinallity: boolean,
    countTabs: Array<any>,
  } = {
      columnInfo: [], columnData: [], totalCount: 0, totalNoOfPages: 0, showCheckBox: false, showExportBtn: false,
      showGraphBtn: false, showSearchBar: false, showAddBtn: false, currentPage: 0, showDeleteBtn: false,
      tabsData: [], tabsMainData: [], showAccessConfigBtn: false, showTitle: false, showBreadCrumbs: true,
      showAuditLog: true, showPermantDeleteBtn: false, showRestoreBtn: false, showImportBtn: false, showBackBtn: false,
      showRefreshFunctinallity: false, countTabs: []
    };


  constructor(private httpService: HttpService,private config: Config,private datePipe: DatePipe,public router: Router, 
    private activatedroute: ActivatedRoute,private encryptionService: EncryptionService,
    public sharedService: SharedService,) { }

  ngOnInit() {
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.activatedroute.params.subscribe((params: any) => {
      this.auditLogId = params?.id;
      this.auditLogModuleName = params?.moduleName;
      this.auditLogNumber = params?.code;
      // this.paginationUrl = this.config.getAllAuditLog + 'Observation' + '/' + this.observationID;
    });

    this.initilaizeColumn()
  }

  ionViewWillEnter() {
    this.getYearsOfCompany();
  }
    
  onClickBackBtn() {
    this.router.navigate(['/home/hrportal/threeSixtyDegree']);
  }

  isChangeDetected: boolean = false;
  currentPage: number = 1;
  auditLogId: any;
  auditLogModuleName:any;
  paginationUrl: any = '';
  showListingPage: boolean = true;
  auditLogNumber:any;
  subModuleButtonColor:any;
  page:any=0;
  renderData:any = [];
  sortName:any='updatedAt';
  sortBy:any='desc'
  yearsOfCompany:any=[];
  essNamesList:any;
  selectedSurveyID:any;
  initilaizeColumn() {
    this.gridData.columnInfo = [];
    this.gridData.columnInfo.push({label: 'Field', propertyName: 'fieldName',sortingName: 'columnName'});
    this.gridData.columnInfo.push({label: 'Old Value', propertyName: 'oldValue',sortingName: 'oldValue'});
    this.gridData.columnInfo.push({label: 'New Value', propertyName: 'newValue',sortingName: 'newValue'});
    this.gridData.columnInfo.push({label: 'Changed By', propertyName: 'lastModifiedBy',sortingName: 'lastModifiedBy'});
    this.gridData.columnInfo.push({label: 'Changed On', propertyName: 'updatedAt',sortingName: 'updatedAt'});
  }
  onChangeSurveyLog(){
    if(this.selectedYear!=null){
      const test = this.selectedYear?.split('-');
      this.httpService.callGetService(this.config.get360AuditLog+ this.selectedSurveyID+ '/'+ this.loggedInUserCompanyID + '/' +
        test[0] + '/' + test[1]).subscribe((data: any) => {
          this.gridData.totalNoOfPages = data?.data?.totalPages;
          this.gridData.totalCount = data?.data?.total;
          this.gridData.currentPage = data?.data?.currentPageNumber;
          this.renderColumnData(data.data?.logs);
      })
    }
  }
  renderColumnData(logData:any){
    this.gridData.columnData = [];
    for (let i = 0; i < logData?.length; i++) {
      this.gridData.columnData.push({
          fieldName: logData[i]?.columnName,
          oldValue: logData[i]?.oldValue,
          newValue: logData[i]?.newValue,
          lastModifiedBy: logData[i]?.firstName+' '+logData[i]?.lastName,
          updatedAt: this.datePipe.transform(logData[i]?.updatedAt,"dd MMM yyyy | hh:mm a"),
        });
    }
    this.isChangeDetected = !this.isChangeDetected
    // this.mapRenderData();
  }
  mapRenderData() {
    this.renderData = [];
    for (let i = 0; i < this.gridData.columnData.length; i++) {
      var output = Object.entries(this.gridData.columnData[i]).map(([key, value]) => ({ key, value }));
      this.renderData.push(output);
    }
  }
  getYearsOfCompany() {
    
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.yearsOfCompany = [];
      data?.data?.yearRanges?.forEach((ele: any) => {
        var test = ele.split('_');
        let obj = {
          year: test[0] + '-' + test[1]
        }
        if (test[0] != null && test[1] != null) {
          this.yearsOfCompany.push(obj);
        }
      });
      
      this.yearsOfCompany?.forEach((ele: any) => {
        const currentYear = new Date().getFullYear();
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth(); 
        let yearValue = '';
        if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
          yearValue = `${currentYear}-${currentYear}`;
        } else {
          yearValue = `${currentYear}-${currentYear + 1}`;
          if(this.loggedInCompanyFiscalyear === 'Apr_Mar'){
            if(currentMonth<3){
              yearValue = `${currentYear-1}-${currentYear}`;
            }else{
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
          if(this.loggedInCompanyFiscalyear === 'July_Jun'){
            if(currentMonth<6){
              yearValue = `${currentYear-1}-${currentYear}`;
            }else{
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
          if(this.loggedInCompanyFiscalyear === 'Oct_Sep'){
            if(currentMonth<9){
              yearValue = `${currentYear-1}-${currentYear}`;
            }else{
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
        }
        if (ele?.year == yearValue) {
          this.selectedYear = ele?.year;
          this.getessName();
        }
      });
    })
  }
  getessName() {
    if(this.selectedYear != null){
      const test = this.selectedYear?.split('-');
      

      this.httpService.callGetService(this.config.reviewName + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1]).subscribe((data: any) => {
        
        this.essNamesList = [];
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            name: ele.reviewName,
          }
          this.essNamesList.push(obj);
          if(ele.reviewStatus == 'Active'){
            this.selectedSurveyID = ele.id;
            this.onChangeSurveyLog();
          }
        });
      })
    }
  }
}
